<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.categories') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <!-- <pre>{{ products }}</pre> -->

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.category')"/>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.category_name') }} *</label>
                    <input
                      ref="category_name"
                      v-model="textfield.category_name"
                      type="text"
                      class="form-control category-name">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          v-if="items.length > 0 && textfield.category_name.trim().length > 0"
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems') + ' ('+assignitems.length+')'"/>
            <div class="col-md-12 row align-items-center no-padding no-margin subheader-assign">
              <div class="col no-padding">{{ $t('message.productlist') }}</div>
            </div>
            <div
              v-for="(item, index) in items"
              :class="{ active: item.active}"
              class="col-md-12 row align-items-center no-padding no-margin item"
              @click="toggleAssign(item)">
              <div class="col">
                {{ item.product_name }}
              </div>
              <div class="col text-right">
                <span v-if="!item.active">
                  {{ item.category_name }}
                </span>
                <span v-if="item.active">
                  {{ textfield.category_name }}
                </span>
                <i class="fas fa-check-circle"/>
                <i class="far fa-circle"/>
              </div>
            </div>
          </div>
        </section>

        <section class="mt-4">
          <div class="col-md-12 no-padding">
            {{ $t('message.applyitemtopos', {item: $t('sidebar.categories')}) }}
            <a
              href="https://www.treesoft.io/th/manual/product#category"
              target="_blank">
              {{ $t('button.learnmore') }}
              <i class="fas fa-external-link-alt"/>
            </a>
          </div>
        </section>

        <section class="action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" @click="clearForm()">{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              @click="save()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  name: 'CategoryNew',
  mixins: [discardFormMixin],
  data () {
    return {
      ready: false,

      textfield: {
        category_name: '',
      },
      items: [],
      assignitems: [],
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
    }),
    form () {
      return {
        textfield: this.textfield,
        items: this.items,
        assignitems: this.assignitems,
      }
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    items: {
      handler: function (after) {
        let items = after
        this.updateAssignItems(items)
      },
      deep: true,
    },
    textfield: {
      handler: function (after) {
        if (after.category_name.trim().length > 0) {
          $(this.$refs.category_name).removeClass('is-invalid')
        } else {
          $(this.$refs.category_name).addClass('is-invalid')
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () { // clear states

  },
  created: async function () { // call api to get data and set state
    // get products
    await this.$store.dispatch('getProducts')
    // set items
    this.setItems(null, this.products)
    // update assignitems
    this.updateAssignItems(this.items)
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 1,
    })
  },
  mounted: function () { // run script

  },
  updated: function () { // re-rendered html

  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts'])
  },
  methods: {
    toggleAssign (item) {
      if (this.textfield.category_name.trim().length == 0) {
        this.textfield.category_name = ''
        return $(this.$refs.category_name).focus().addClass('is-invalid')
      }
      item.active = !item.active
    },
    clearForm () {
      this.ready = false

      this.textfield.category_name = ''
      this.setItems(null, this.products)

      setTimeout(() => {
        this.ready = true
      }, 1)
    },
    async save () {
      if (this.textfield.category_name.trim().length == 0) {
        return $(this.$refs.category_name).focus().addClass('is-invalid')
      }

      let data = {
        category_name: this.textfield.category_name,
      }

      if (this.assignitems.length > 0) {
        data['assign'] = this.assignitems
      }

      let res = await this.$store.dispatch('insertCategory', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: this.textfield.category_name }),
          color: 'success',
          icon: 'cloud',
        })
        // go to GoodsIssueAll page
        return this.$router.push({
          name: 'CategoryAll',
          query: {
            ignoreDiscardAlert: true,
          },
        })
      }
    },
    setItems (category, products) {
      this.items = []
      for (let i in products) {
        let product = products[i]
        var active = false
        if (category) {
          if (category.category_id == product.category_id) {
            active = true
          }
        }
        this.items.push({
          product_id: product.product_id,
          product_name: product.product_name,
          category_id: product.category_id,
          category_name: product.category_name,
          active: active,
        })
      }
    },
    updateAssignItems (items) {
      this.assignitems = []
      for (let i in items) {
        let item = items[i]
        if (item.active) {
          this.assignitems.push({
            product_id: item.product_id,
          })
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/category/New.vue